import React, { useCallback } from 'react'
import { Link } from 'react-router'
import classnames from 'classnames'
import { useSelector, useDispatch } from 'react-redux'
import Sticky from 'react-stickynode'
import PropTypes from 'prop-types'
import exact from 'prop-types-exact'
import MenuProfile from '../../components/menu/MenuProfile'
import BrandLogo from './BrandLogo'
import MainNavigation from './MainNavigation'
import CurrentWeatherNavBar from './weather/CurrentWeatherNavBar'
import MenuNamedays from './MenuNamedays'
import MenuSearchToggle from './MenuSearchToggle'
import './menu.pcss'
import { selectUserFrontPage, selectUserName } from '../../selectors/userSelector'
import { openSearch } from '../../views/Search/searchActions'

const Menu = ({ searchOpen, isOpen, loggedIn, path }) => {
  const dispatch = useDispatch()
  const frontPage = useSelector(selectUserFrontPage)
  const userName = useSelector(selectUserName)

  const handleSearchOpen = useCallback(() => {
    dispatch(openSearch())
  }, [dispatch])

  return (
    <Sticky className={ classnames('top-menu', {'blur': isOpen}) } innerZ={ 22 }>
      <div className={ classnames('top-menu__container top-menu__container_outer') }>
        <div className='top-menu__container top-menu__container_inner outer-container'>

          <div className='menu-bar'>
            <div className='menu-bar__column menu-bar__column_logo'>
              <BrandLogo
                frontPage={ frontPage }
                path={ path }
              />
            </div>

            <div className='menu-bar__column menu-bar__column_pages'>
              <MainNavigation />
            </div>

            <div className='menu-bar__column menu-bar__column_search'>
              <MenuSearchToggle searchOpen={ searchOpen } onSearchOpen={ handleSearchOpen } />
            </div>

            <div className='menu-bar__column menu-bar__column_stats'>
              <MenuNamedays />
            </div>

            <div className='menu-bar__column menu-bar__column_weather'>
              <Link to='/saa' title='10 vrk sääennusteeseen'>
                <CurrentWeatherNavBar />
              </Link>
            </div>

            <div className='menu-bar__column menu-bar__column_login'>
              <MenuProfile
                dispatch={ dispatch }
                loggedIn={ loggedIn }
                userName={ userName }
              />
            </div>

          </div>
        </div>
      </div>
    </Sticky>
  )
}

Menu.propTypes = exact({
  searchOpen: PropTypes.bool.isRequired,
  isOpen: PropTypes.bool.isRequired,
  loggedIn: PropTypes.bool.isRequired,
  path: PropTypes.string.isRequired,
})

export default Menu
